import ModuleManager from "../../../../framework/core/module_manager"
import MVVMBase from "../../../../framework/core/mvvm/mvvm_base"
import AppData from "../../../public/const/app_data"
import ModelData from "../../../public/model_data"
import { Long } from "protobufjs"
import { RedPointModule } from "../../../public/component/redpoint_component"
import EventManager from "../../../../manager/event_manager"
import { joinUtil } from "../../../public/join_util"
import Shop from "../shop/shop"
import { NotifyData } from "../../../public/notify_data"
import LoaclStorage from "../../../../manager/local_storage"
import TimeManager from "../../../../manager/time_manager"

export interface IGameRedPoint{
    isHave:boolean;
    userData?:any;
}


export class TaskCode{
    static readonly day_welfare: string = 'day_welfare'
    static readonly bankruptcy:string ='bankruptcy';
    static readonly total_round:string = 'total_round';
    static readonly total_winlose:string = 'total_winlose';
    static readonly invite_award:string = 'invite_award';
    static readonly first_goods:string = 'first_goods'
}


export class TaskHelp {
    protected static code_url_map:{[k:string]:string} = {
        [TaskCode.day_welfare]: 'activity/daywelfare/getDayWelfareProgressV2?',
        [TaskCode.bankruptcy]:'activity/bankruptcy/getBankruptcyProgress?',
        [TaskCode.total_round]:'activity/totalround/getTotalRoundProgress?',
        [TaskCode.total_winlose]:'activity/totalwinlose/getTotalWinloseProgress?',
        [TaskCode.invite_award]:'activity/inviteaward/getInviteAwardProgress?',
        [TaskCode.first_goods]:'activity/firstgoods/getFirstGoodsProgress?',
    }

    protected static code_url_task:{[k:string]:string} = {
        [TaskCode.day_welfare]:'activity/daywelfare/getDayWelfareActivity?',
        [TaskCode.bankruptcy]:'activity/bankruptcy/getBankruptcyActivity?',
        [TaskCode.total_round]:'activity/totalround/getTotalRoundActivity?',
        [TaskCode.total_winlose]:'activity/totalwinlose/getTotalWinloseActivity?',
        [TaskCode.invite_award]:'activity/inviteaward/getInviteAwardActivity?',
        [TaskCode.first_goods]:'activity/firstgoods/getFirstGoodsActivity?'
    }

    //获取任务列表
    static queryTaskList(success, fail, mvvmBase: MVVMBase){
        let requestData: IHttpRequestData = {
            baseUrl:'activity/queryList?',
            params: {
                showType:3,
            },
            useCache:true,
        }
        TaskHelp._get_http(requestData, success, fail, mvvmBase)
    }

    static getTaskDetailRequest(code:string):IHttpRequestData{
        let url = TaskHelp.code_url_task[code];
        if (!url) {
            return;
        }
        let requestData: IHttpRequestData = {
            baseUrl:url,
            params: {},
        }
        return requestData
    }

    static getCodeTaskProgress(code: string, activityId): IHttpRequestData{
        let url = TaskHelp.code_url_map[code];
        if (!url) {
            return;
        }
        let requestData: IHttpRequestData = {
            baseUrl:url,
            params: {
                activityId: activityId,
            },
        }
        return requestData
    }

    static requestDrawActivityAward(activityId, success, fail, mvvmBase: MVVMBase){
        let requestData:IHttpRequestData = {
            baseUrl:'activity/receive?',
            params: {
                activityId: activityId,
            },
        }
        TaskHelp._get_http(requestData, success, fail, mvvmBase)
    }

    //奖励检测6 mongo 5 chips
    static checkAwardResult(moneyType:number,func:(isReceive:boolean,moneyType:number)=>void,mvvmBase:MVVMBase){
        NotifyData.instance.reqRedPointMsg((data:any)=>{
            let isCanReceive = data && data.taskTotalCount > 0
            func && func(isCanReceive,moneyType);
        })
    }

    //检测是否可以领取
    static checkIsCanReceive(func:(isReceive:boolean)=>void,mvvmBase:MVVMBase){
        TaskHelp.queryTaskList((dataList)=>{
            let maxCount = dataList.length;
            dataList.sort((a,b)=>{
                if (a.activityCode == TaskCode.day_welfare) {
                    return -1;
                }
                return 0;
            })

            for (let i = 0; i < dataList.length; i++) {
                let element = dataList[i];
                let redPoint = TaskHelp.getRedPoint(element.activityCode)
                if (redPoint && redPoint.isHave) {
                    func && func(true);
                    TaskHelp.refreshRedPoint(true);
                    return;
                }
            }

            let checkProgress=(index)=>{
                if (index >= maxCount) {
                    func && func(false);
                    TaskHelp.refreshRedPoint(false);
                    return;
                }else{
                    let dataDetail = dataList[index];
                    TaskHelp.getTaskProgress(dataDetail.activityCode,dataDetail.activityId,(data)=>{
                        if (data.isReceive) {//可以领取
                            TaskHelp.setRedPoint(dataDetail.activityCode,true)
                            func && func(true);
                        }else{
                            checkProgress(++index)
                        }
                    },()=>{},mvvmBase)
                }
            }
            checkProgress(0);
        },()=>{},mvvmBase);
    }

    static getAllTask(success,mvvmBase:MVVMBase){
        TaskHelp.queryTaskList((datalist)=>{
            let dataMap = [];
            for (let index = 0; index < datalist.length; index++) {
                let activity = datalist[index];
                let data = {
                    activityCode:activity.activityCode,
                    activityId:activity.activityId,
                }
                dataMap.push(data);
            }

            let setData = (key:string,_data:any)=>{
                for (let i = 0; i < _data.length; i++) {
                    let task = _data[i];
                    if (task.progress == undefined) {
                        continue;
                    }
                    for (let idx = 0; idx < dataMap.length; idx++) {
                        let data = dataMap[idx];
                        if (task.activityCode == data.activityCode) {
                            data[key] = _data[i]
                            break;
                        }
                    }
                }
            }

            TaskHelp.getTasksDetails(datalist,(data)=>{
                    setData('taskdata',data);
                    success && success(dataMap);
                },mvvmBase)

        },()=>{},mvvmBase)
    }

    static getTasksDetails(activityData: any[], success, mvvmBase: MVVMBase){
        let requestDatas: IUrlRequestAllData[] = []
        for (let index = 0; index < activityData.length; index++) {
            const data = activityData[index];
            if(TaskHelp.code_url_task[data.activityCode]){
                requestDatas.push({requestData: TaskHelp.getTaskDetailRequest(data.activityCode)})
            }
        }
        TaskHelp._get_http_all(requestDatas, function(allData: IUrlResponseAllData){
            let dataList = []
            for (let index = 0; index < requestDatas.length; index++) {
                const element = requestDatas[index];
                let tmpData = allData.responseDataMap[element.requestData.baseUrl]
                if(tmpData && tmpData.successData){
                    if(tmpData.successData.code == 'SUCCESS' && tmpData.successData.data){
                        if (tmpData.successData.data.activityId != undefined) {
                            dataList.push(tmpData.successData.data)
                        }
                    }                    
                }
            }
            if (dataList.length > 0) {
                success && success(dataList)
            }
        }, mvvmBase)
    }

    static getTasksProgress(activityData: any[], success, mvvmBase: MVVMBase){
        let requestDatas: IUrlRequestAllData[] = []
        for (let index = 0; index < activityData.length; index++) {
            const data = activityData[index];
            requestDatas.push({requestData: TaskHelp.getCodeTaskProgress(data.activityCode, data.activityId)})
        }
        TaskHelp._get_http_all(requestDatas, function(allData: IUrlResponseAllData){
            let dataList = []
            for (let index = 0; index < requestDatas.length; index++) {
                const element = requestDatas[index];
                let tmpData = allData.responseDataMap[element.requestData.baseUrl]
                if(tmpData && tmpData.successData){
                    if(tmpData.successData.code == 'SUCCESS' && tmpData.successData.data){
                        dataList.push(tmpData.successData.data)
                    }                    
                }
            }
            success && success(dataList)
        }, mvvmBase)
    }

    static isHaveDayWelfare(func:(isHave:boolean)=>void,mvvm_base:MVVMBase){
        TaskHelp.getTaskDetail(TaskCode.day_welfare,(data:any)=>{
            let progress = data.progress;

            let tag = TaskHelp.getDayWelfareState(progress);
            let isCanReceive = progress.isReceive && !progress.isFinish
            if (tag !=0 ) {
                let remainTime = TaskHelp.remainingTime();
                if (tag == 2) {//当前是重置倒计时
                    if (remainTime > 0) {//还有重置时间
                        isCanReceive = false;
                    }
                }
            }
            func && func(isCanReceive)
        },()=>{
            func && func(false);
        },mvvm_base);
    }

    //isbankruptcy 是否破产
    static isBankruptcy(func:(isbankruptcy:boolean,remainCnt?:number,accountType?:number,amount?:number)=>void, mvvmBase: MVVMBase){
        TaskHelp.getTaskDetail(TaskCode.bankruptcy,(arg)=>{
            let isbankruptcy = false;
            if (arg.activityId != undefined) {
                if (arg) {
                    let progress = arg.progress;
                    isbankruptcy = progress.isReceive;
                    if (isbankruptcy) {//破产直接领取
                        TaskHelp.requestDrawActivityAward(arg.activityId,(data)=>{
                            let award = progress.awards[0]
                            let mtype = award.activityAmountType
                            let cnt = award.amount
                            let count = Math.abs(progress.maxCount-progress.currentCount)//剩余数量
                            func && func(isbankruptcy,count,mtype,cnt);
                            mvvmBase.getSelfCurrencyData(null, true,true);//更新货币
                            TaskHelp.setRedPoint(TaskCode.bankruptcy,false);//去掉红点
                        },()=>{},mvvmBase);
                    }else{
                        func && func(isbankruptcy,0);
                    }
                }else{
                    func && func(isbankruptcy,0);
                }
            }else{
                func && func(isbankruptcy,0);
            }
        },()=>{
            func && func(false,0);
        },mvvmBase)
    }

    static getTaskDetail(code:string,success:Function,fail:Function,mvvm_base:MVVMBase){
        let requestData = TaskHelp.getTaskDetailRequest(code);
        if (requestData) {
            TaskHelp._get_http(requestData,(data)=>{
                success && success(data)
            },fail,mvvm_base)
        }
    }

    //获取其中一个任务
    static getTask(code:string,success, fail, mvvmBase: MVVMBase){
        let requestData = TaskHelp.getTaskDetailRequest(code);
        TaskHelp._get_http(requestData, (taskData)=>{
            if (taskData.activityId != undefined) {
                TaskHelp.getTaskProgress(code,taskData.activityId,(progressData)=>{
                    success && success(taskData,progressData)
                },fail,mvvmBase);
            }else{
                success && success(null);
            }
        }, fail, mvvmBase)
    }


    
    private static getTaskProgress(taskCode:string,activityId,success, fail, mvvmBase: MVVMBase){
        let requestData = TaskHelp.getCodeTaskProgress(taskCode,activityId);
        TaskHelp._get_http(requestData, success, fail, mvvmBase)
    }

    //获取红点
    protected static mRedPoint:Map<string,IGameRedPoint> = new Map<string,IGameRedPoint>();

    protected static userId:number|Long;

    static getRedPoint(key:string):IGameRedPoint{
        if (TaskHelp.userId !=  ModelData.instance.roleData.id) {
            TaskHelp.clearRedPoint();
            TaskHelp.userId = ModelData.instance.roleData.id
            return null;
        }
        return TaskHelp.mRedPoint.get(key);
    }

    static clearRedPoint(){
        TaskHelp.mRedPoint.clear();
    }

    static setRedPoint(key:string,isHave:boolean,data?:any){

        TaskHelp.mRedPoint.set(key,{
                isHave:isHave,
                userData:data,})

        if (isHave) {
            TaskHelp.refreshRedPoint(true);
        }
    }

    //点击领取之后刷新
    static checkAllRedPoint(mvvmBase:MVVMBase){
        let isHave = false;
        TaskHelp.mRedPoint.forEach((v:IGameRedPoint,k:string)=>{
            if (!isHave && v.isHave) {
                isHave = true;
            }
        })
        TaskHelp.refreshRedPoint(isHave);
    }

    static refreshRedPoint(isHave:boolean){
        EventManager.instance.dispatch('Event_Notify_RedPoint_Change', RedPointModule.Task, isHave ? 1:0);
        EventManager.instance.dispatch('Event_Notify_RedPoint_Refresh');
    }

    private static _get_http(requestData, success, fail, mvvmBase: MVVMBase){
        mvvmBase.apiHttpGet(requestData,  (retData)=>{
            if (retData.code == 'SUCCESS') {
                success(retData.data)
            } else {
                fail(retData)
            }
        }, (retData) => {
            ModuleManager.instance.toast500error(retData)
            fail(retData)
        })
    }

    private static _get_http_all(requestDatas: IUrlRequestAllData[], onAllFinish: (data: IUrlResponseAllData) => void, mvvmBase: MVVMBase){
        if (requestDatas.length > 0) {
            mvvmBase.http_get_all(requestDatas, onAllFinish)
        }
    }

    static requestDayWelfare(success:Function,mvvm_base:MVVMBase){
        TaskHelp.getTaskDetail(TaskCode.day_welfare,(data:any)=>{
            success && success(data);
        },()=>{},mvvm_base);
    }

    //task new need

    //任务奖励
    static taskAward(taskRefId:number,taskTypeCode:string, success:Function, mvvmBase: MVVMBase){
        let requestData:IHttpRequestData = {
            baseUrl:'activity/task/receiveTask?',
            params: {
                taskRefId: taskRefId,
                taskTypeCode:taskTypeCode
            },
            showNetPrompt:true,
        }
        TaskHelp._get_http(requestData, success, ()=>{}, mvvmBase)
    }

    static getTaskByCode(taskType: string): IHttpRequestData{
        let requestData: IHttpRequestData = {
            baseUrl:'activity/task/getUserTask?',
            params: {
                taskTypeCode:taskType
            },
        }
        return requestData
    }

    static getUserTask(taskcodes:string[],success, mvvmBase: MVVMBase){
        let requestDatas: IUrlRequestAllData[] = []
        for (let index = 0; index < taskcodes.length; index++) {
            const code = taskcodes[index];
            requestDatas.push({requestData: TaskHelp.getTaskByCode(code)})
        }

        TaskHelp._get_http_all(requestDatas, function(allData: IUrlResponseAllData){
            let dataList = []
            for (let index = 0; index < requestDatas.length; index++) {
                const element = requestDatas[index];
                let tmpData = allData.responseDataMap[element.requestData.baseUrl]
                if(tmpData && tmpData.successData){
                    if(tmpData.successData.code == 'SUCCESS' && tmpData.successData.data){
                        dataList.push(tmpData.successData.data)
                    }                    
                }
            }
            if (dataList.length > 0) {
                success && success(dataList)
            }
        }, mvvmBase)
    }

    //是否有奖励可领取
    static isCanReceive(data:any[]):boolean{
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let isCanReceive = item.isFinish && !item.isReceive;
            if (isCanReceive) {
                return true;
            }
        }
        return false;
    }

    //映射表
    protected static codeToGameId:{[k:string]:string} = {
        ['BP']:'TM_BP',
        ['Q2']:'TM_Q2',
        ['K9']:'TM_JK',
        ['9D']:'TM_JD'
    }

    static goToFinishTask(code:string){
        cc.log('-->>>gotoTask',code);
        let str = code.split('_');
        let params = null;
        if (str && str[0] ) {
            let funcName = str[0]
            params = TaskHelp.codeToGameId[funcName]
            if (params) {
                funcName = 'GoToGame';//游戏跳转
            }

            let func = TaskHelp.taskCondition[funcName];
            if (func) {
                func(params);
            }
        }
    }

    protected static taskCondition:{[k:string]:Function} = {
        ['GoToGame']:TaskHelp.goToGame,
        ['SHOP']:TaskHelp.gotoShop,
    }

    protected static goToGame(gameName:string){
        joinUtil.openGoleEntrance(gameName)
    }

    protected static gotoShop(){
        ModuleManager.instance.showModule(Shop)
    }

    static isSysType(code:string){
        return TaskHelp.getTaskType(code,'SYS')
    }

    protected static getTaskType(code:string,useType:string){
        let str = code.split('_');
        if (str && str[0]) {
            if (str[0] == useType) {
                return true;
            }
        }
        return false;
    }

    //倒计时
    static startTime:number = 0;

    //登录就计时，退出清空
    static setLoginTime(){
        if (TaskHelp.startTime == 0) {
            TaskHelp.startTime = TimeManager.instance.getServerTime();
        }
    }

    static clear(){
        TaskHelp.startTime = 0;
    }

    //tag: 0:未设置值,1.reset倒计时 tag:2.next领取倒计时,3.可领取
    static saveDayWelfareState(tag:number,time=0){
        LoaclStorage.setNumber(ModelData.instance.roleData.id+'_remain_time_tag',tag);
        if (time >= 0) {
            TaskHelp.setRemainTime(time);
        }
    }

    static getDayWelfareState(progress){
        let tag = LoaclStorage.getNumber(ModelData.instance.roleData.id+'_remain_time_tag',0);
        if (tag == 0 || tag == 1 || tag == 3) {
            TaskHelp.updateDayWelFareState(progress);
        }
        return  tag
    }


    static updateDayWelFareState(progress:any){
        if (!progress) {
            return;
        }

        if (progress.isFinish) {//reset时间不算在计时内
            TaskHelp.saveDayWelfareState(1,0);
        }else{
            if (progress.isReceive) {
                TaskHelp.saveDayWelfareState(3);
            }else{
                TaskHelp.saveDayWelfareState(2,progress.nextReceiveSencod || 0);
            }
        }
    }
    

    static remainingTime(){
        let curTime =  TimeManager.instance.getServerTime();
        let remain = curTime - TaskHelp.startTime;
        let localTime = <number>LoaclStorage.getNumber(ModelData.instance.roleData.id+'_remain_time',0) || 0;
        if (localTime <= 0) {
            return 0;
        }
        let dis = localTime - remain;
        let remainTime = dis <= 0 ? 0 : dis;
        TaskHelp.setRemainTime(remainTime);
        return remainTime
    }

    static setRemainTime(time:number){
        LoaclStorage.setNumber(ModelData.instance.roleData.id+'_remain_time',time);
        TaskHelp.startTime = TimeManager.instance.getServerTime();
    }


}
